<template>
  <v-dialog v-model="$store.state.messageDialog.isShowing" max-width="700px">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-card-title>
          <span class="headline">{{this.$vuetify.lang.translator("messageForm.messageTitle")}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  :counter="30"
                  :rules="nameRules"
                  :label="this.$vuetify.lang.translator('messageForm.nameField')"
                  required
                  v-model="name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  :rules="emailRules"
                  :label="this.$vuetify.lang.translator('messageForm.emailField')"
                  required
                  v-model="email"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-autocomplete
                  :items="$store.getters.getAppTitles"
                  :label="this.$vuetify.lang.translator('messageForm.appField')"
                  v-model="$store.state.messageDialog.currentAppName"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <vue-recaptcha
                  ref="recaptcha"
                  :sitekey="sitekey"
                  @verify="register"
                  @expired="onCaptchaExpired"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :counter="500"
                  :rules="messageRules"
                  name="input-7-1"
                  :label="this.$vuetify.lang.translator('messageForm.message')"
                  auto-grow
                  v-model="message"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!isValidForm"
            color="blue darken-1"
            text
            @click="sendMessageIfCan()"
          >{{this.$vuetify.lang.translator('messageForm.sendButton')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  props: {},
  components: { VueRecaptcha },
  data() {
    return {
      lazy: false,
      valid: false,
      name: "",
      email: "",
      message: "",
      sitekey: "6LeBnsAZAAAAAAi5ykC2hRHypS3JPw_ZkoGYGUPF",
      token: null,
      messageRules: [
        (v) => !!v || this.$vuetify.lang.translator("messageForm.isRequired"),
        (v) =>
          (v && v.length <= 500) ||
          this.$vuetify.lang.translator("messageForm.mustBeLess", 500),
      ],
      nameRules: [
        (v) => !!v || this.$vuetify.lang.translator("messageForm.isRequired"),
        (v) =>
          (v && v.length <= 30) ||
          this.$vuetify.lang.translator("messageForm.mustBeLess", 30),
      ],
      emailRules: [
        (v) => !!v || this.$vuetify.lang.translator("messageForm.isRequired"),
        (v) =>
          /.+@.+\..+/.test(v) ||
          this.$vuetify.lang.translator("messageForm.incorrectEmail"),
      ],
    };
  },
  computed: {
    isValidForm() {
      return this.valid && this.token != null;
    },
    appTitle() {
      return this.$store.getters.getTitleOfCurrentApp;
    },
  },
  methods: {
    register(recaptchaToken) {
      console.log("recaptchaToken :>> ", recaptchaToken);
      this.token = recaptchaToken;
    },

    validate() {
      this.$refs.recaptcha.execute();
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    clearData() {
      this.name = "";
      this.email = "";
      this.message = "";
    },
    sendMessageIfCan() {
      this.$refs.form.validate();
      if (!this.isValidForm) {
        return;
      }
      this.$store.commit("showSnackbar", {
        text: this.$vuetify.lang.translator("messageForm.messageSuccess"),
        color: "success",
      });
      this.$store.commit("hideMessageDialog");
      this.$store.dispatch("sendMessageAction", {
        name: this.name,
        email: this.email,
        app: this.appTitle,
        message: this.message,
        lang: this.$vuetify.lang.current,
        token: this.token,
      });
    },
  },
  watch: {},
  beforeCreate() {
    // console.log("beforeCreate");
  },
  beforeMount() {
    // console.log(`beforeMount`);
  },
  mounted() {
    // console.log("mounted");
  },
  beforeUpdate() {
    // console.log("beforeUpdate");
  },
  created() {
    // console.log("created");
  },
  updated() {
    // console.log("updated");
  },
  beforeDestroy() {
    // console.log("beforeDestroy");
  },
  destroyed() {
    // console.log("destroyed");
  },
};
</script>


<style scoped>
</style>
